import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { light } from './theme'
import { red } from './theme'
import { green } from './theme'
import { black } from './theme'
import { geodisLight } from '@@/styles/theme'
import DatetimePicker from 'vuetify-datetime-picker'
import i18n from '@/plugins/i18n';

import icons, { customPropsIcons } from '../../Graph/icons/';

const getIcons = (icons) => {
  let obj = {};
  Object.keys(icons).forEach(key => {
    obj[key] = {
      component: icons[key],
    };
  });

  obj = {...obj, ...customPropsIcons}

  return obj;
};

const values = getIcons(icons);
const getTheme = (env) => THEMES[env];

const THEMES = {
  "DEV": { ...geodisLight, ...light, ...black   },
  "PO":  { ...geodisLight, ...light, ...black },
  "UAT": { ...geodisLight, ...light, ...green },
  "PRD": { ...geodisLight, ...light           },
  "INT": { ...geodisLight, ...light, ...red },
};

Vue.use(Vuetify)
Vue.use(DatetimePicker)

export default new Vuetify({
  icons: { iconfont: 'mdi', values },
  theme: {
    options: {
      customProperties: true,
    },
    /* to set a theme in your local env just place the folowing line in your env.local file
     * VUE_APP_ENV=DEV
     * Replacing DEV by your wanted env, CD pipeline overwrites this setting by the one specified 
     * in the src/environments/ folder according to the deplyed env
    */
    themes: { light: getTheme(process.env.VUE_APP_ENV || envConfig.VUE_APP_ENV) }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
})

